"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var array_1 = require("./array");
var isEmpty_1 = require("./isEmpty");
var types_1 = require("./types");
var big_data_1 = require("./big-data");
var isUnNormalObject = function (value) {
    if ((value === null || value === void 0 ? void 0 : value._owner) || (value === null || value === void 0 ? void 0 : value.$$typeof)) {
        return true;
    }
    if ((value === null || value === void 0 ? void 0 : value._isAMomentObject) || (value === null || value === void 0 ? void 0 : value._isJSONSchemaObject)) {
        return true;
    }
    if ((value === null || value === void 0 ? void 0 : value.toJS) || (value === null || value === void 0 ? void 0 : value.toJSON)) {
        return true;
    }
};
var isPlainValue = function (val) {
    if (isUnNormalObject(val)) {
        return false;
    }
    if (big_data_1.BigData.isBigData(val)) {
        return false;
    }
    return types_1.isPlainObj(val) || types_1.isArr(val);
};
exports.defaults = function (defaults_, targets) {
    if (types_1.getType(defaults_) !== types_1.getType(targets) ||
        !isPlainValue(defaults_) ||
        !isPlainValue(targets)) {
        return isEmpty_1.isValid(targets) ? targets : defaults_;
    }
    else {
        var results_1 = types_1.isPlainObj(defaults_) ? {} : [];
        array_1.each(targets, function (value, key) {
            results_1[key] = exports.defaults(defaults_[key], value);
        });
        array_1.each(defaults_, function (value, key) {
            if (!isEmpty_1.isValid(results_1[key])) {
                results_1[key] = value;
            }
        });
        return results_1;
    }
};
